import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** Aviso flotante del prototipo (.toast.show). */
export function Toast({ message }: { message: string | null }) {
  return (
    <div className={message ? 'toast show' : 'toast'} role="status" aria-live="polite">
      {message}
    </div>
  );
}

/** Ventana modal del prototipo: .modal.show > .modalcard > .modalhead. */
export function Modal({
  open,
  title,
  help,
  onClose,
  children,
}: {
  open: boolean;
  title: ReactNode;
  help?: ReactNode;
  onClose: () => void;
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <div className={open ? 'modal show' : 'modal'} role="dialog" aria-modal="true" aria-hidden={!open}>
      <div className="modalcard">
        <div className="modalhead">
          <div>
            <h3>{title}</h3>
            {help ? <p className="help">{help}</p> : null}
          </div>
          <button type="button" className="close" aria-label={t('common.close')} onClick={onClose}>
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
